<template>
  <div>
    <div class="container-fluid">
      <div class="row orta">
        <div class="col-md-10">
          <vx-card>
            <vs-row>
              <vs-col
                vs-type="flex"
                vs-justify="flex-start"
                vs-align="flex-start"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button icon="arrow_back" to="/properties">{{
                  $t("back")
                }}</vs-button>
              </vs-col>

              <vs-col
                vs-type="flex"
                vs-justify="flex-end"
                vs-align="flex-end"
                vs-lg="6"
                vs-sm="6"
                vs-md="6"
              >
                <vs-button
                  icon="save"
                  :disabled="!validateForm"
                  @click="saveProperty"
                  >{{ $t("save") }}</vs-button
                >
              </vs-col>
            </vs-row>

            <div class="vx-row justify-content-center">
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/3">
                <v-select
                  v-validate="'required'"
                  :name="$t('type')"
                  class="mt-6 w-full"
                  :placeholder="$t('type')"
                  label="entityName"
                  :closeOnSelect="true"
                  v-model="obj.TypeEntityId"
                  :options="entities"
                  :reduce="(entities) => entities.id"
                />
                <span class="text-danger text-sm">{{
                  errors.first($t("type"))
                }}</span>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/3">
                <v-select
                  v-validate="'required'"
                  :name="$t('selectCategory')"
                  class="mt-6 w-full"
                  :placeholder="$t('selectCategory')"
                  label="categoryName"
                  :closeOnSelect="true"
                  v-model="obj.CategoryId"
                  :options="categories"
                  :reduce="(categories) => categories.id"
                />
                <span class="text-danger text-sm">{{
                  errors.first($t("selectCategory"))
                }}</span>
              </div>
              <div class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/3">
                <vs-input
                  v-validate="'required|min:3'"
                  :name="$t('featureName')"
                  :label-placeholder="$t('featureName')"
                  v-model="obj.PropertyName"
                  class="w-full mt-6"
                />
                <span class="text-danger text-sm">{{
                  errors.first($t("featureName"))
                }}</span>
              </div>
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import http from "../../../http/http-helper";
import notify from "../../../shared/toast";

export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.obj.TypeEntityId != "" &&
        this.obj.PropertyName != "" &&
        this.obj.CategoryId != ""
      );
    },
  },
  data() {
    return {
      obj: {
        TypeEntityId: "",
        PropertyName: "",
        CategoryId: "",
      },
      categories: [],
      entities: [],
    };
  },
  methods: {
    getEntities() {
      let path = "/properties/getentitylist";
      http.get(path).then((response) => {
        response.forEach((element) => {
          if (element.entityName === "number") {
            element.entityName = this.$t("number");
          }
          if (element.entityName === "text") {
            element.entityName = this.$t("text");
          }
          this.entities = response;
        });
      });
    },
    getCategories() {
      /*if (this.$store.state.role == "Admin") {
        let path = "/categories/GetList";
        http.get(path).then((response) => {
          this.categories = response;
        });
      }
      if (this.$store.state.role == "User") {
        let path = "/categories/getByUserId";
        http
          .post(path, {
            RequestPage: 1,
            UserId: parseInt(this.$store.state.userId),
          })
          .then((response) => {
            this.categories = response.data;
          });
      }*/
      let path = "/categories/GetList";
      http.get(path).then((response) => {
        this.categories = response;
      });
    },
    saveProperty() {
      var number = parseInt(this.obj.TypeEntityId);
      this.obj.TypeEntityId = number;
      let path = "/properties/add";
      http.post(path, this.obj).then((response) => {
        notify.success(this.$t("saved"));
        this.$router.push("/properties");
      });
    },
  },
  created() {
    this.getCategories();
    this.getEntities();
  },
};
</script>

<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>